import React from 'react';

const History = () => (
  <h2>Payment History</h2>
);

export default History;
